import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Bus = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32 "
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M11 20.25C10.0335 20.25 9.25 21.0335 9.25 22C9.25 22.9665 10.0335 23.75 11 23.75C11.9665 23.75 12.75 22.9665 12.75 22C12.75 21.0335 11.9665 20.25 11 20.25ZM10.75 22C10.75 21.8619 10.8619 21.75 11 21.75C11.1381 21.75 11.25 21.8619 11.25 22C11.25 22.1381 11.1381 22.25 11 22.25C10.8619 22.25 10.75 22.1381 10.75 22Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M21 20.25C20.0335 20.25 19.25 21.0335 19.25 22C19.25 22.9665 20.0335 23.75 21 23.75C21.9665 23.75 22.75 22.9665 22.75 22C22.75 21.0335 21.9665 20.25 21 20.25ZM20.75 22C20.75 21.8619 20.8619 21.75 21 21.75C21.1381 21.75 21.25 21.8619 21.25 22C21.25 22.1381 21.1381 22.25 21 22.25C20.8619 22.25 20.75 22.1381 20.75 22Z"
                fill={props.color ? props.color : "white"} />
            <path
                d="M14 9C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11H18C18.5523 11 19 10.5523 19 10C19 9.44772 18.5523 9 18 9H14Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M8 5C6.34315 5 5 6.34315 5 8V24C5 25.3062 5.83481 26.4175 7 26.8293L7 28.0004C7 29.1054 7.8959 30 9 30H10C11.1046 30 12 29.1046 12 28V27H20V28.0004C20 29.1054 20.8959 30 22 30H23C24.1046 30 25 29.1046 25 28V26.8293C26.1652 26.4175 27 25.3062 27 24V8C27 6.34315 25.6569 5 24 5H8ZM9 28V27H10V28H9ZM25 24C25 24.5523 24.5523 25 24 25H8C7.44772 25 7 24.5523 7 24V19H25V24ZM25 17H7V8C7 7.44772 7.44772 7 8 7H24C24.5523 7 25 7.44772 25 8V17ZM22 28V27H23V28H22Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Bus;
